export const quot = '\u0022';
export const amp = '\u0026';
export const apos = '\u0027';
export const gt = '\u003E';
export const nbsp = '\u00A0'; // NON-BREAKING SPACE
export const zwsp = '\u200B'; // ZERO WIDTH SPACE
export const iexcl = '\u00A1';
export const cent = '\u00A2';
export const pound = '\u00A3';
export const curren = '\u00A4';
export const yen = '\u00A5';
export const brvbar = '\u00A6';
export const sect = '\u00A7';
export const uml = '\u00A8';
export const copy = '\u00A9';
export const ordf = '\u00AA';
export const laquo = '\u00AB';
export const not = '\u00AC';
export const shy = '\u00AD';
export const reg = '\u00AE';
export const macr = '\u00AF';
export const deg = '\u00B0';
export const plusmn = '\u00B1';
export const sup2 = '\u00B2';
export const sup3 = '\u00B3';
export const acute = '\u00B4';
export const micro = '\u00B5';
export const para = '\u00B6';
export const middot = '\u00B7';
export const cedil = '\u00B8';
export const sup1 = '\u00B9';
export const ordm = '\u00BA';
export const raquo = '\u00BB';
export const frac14 = '\u00BC';
export const frac12 = '\u00BD';
export const frac34 = '\u00BE';
export const iquest = '\u00BF';
export const Agrave = '\u00C0';
export const Aacute = '\u00C1';
export const Acirc = '\u00C2';
export const Atilde = '\u00C3';
export const Auml = '\u00C4';
export const Aring = '\u00C5';
export const AElig = '\u00C6';
export const Ccedil = '\u00C7';
export const Egrave = '\u00C8';
export const Eacute = '\u00C9';
export const Ecirc = '\u00CA';
export const Euml = '\u00CB';
export const Igrave = '\u00CC';
export const Iacute = '\u00CD';
export const Icirc = '\u00CE';
export const Iuml = '\u00CF';
export const ETH = '\u00D0';
export const Ntilde = '\u00D1';
export const Ograve = '\u00D2';
export const Oacute = '\u00D3';
export const Ocirc = '\u00D4';
export const Otilde = '\u00D5';
export const Ouml = '\u00D6';
export const times = '\u00D7';
export const Oslash = '\u00D8';
export const Ugrave = '\u00D9';
export const Uacute = '\u00DA';
export const Ucirc = '\u00DB';
export const Uuml = '\u00DC';
export const Yacute = '\u00DD';
export const THORN = '\u00DE';
export const szlig = '\u00DF';
export const agrave = '\u00E0';
export const aacute = '\u00E1';
export const acirc = '\u00E2';
export const atilde = '\u00E3';
export const auml = '\u00E4';
export const aring = '\u00E5';
export const aelig = '\u00E6';
export const ccedil = '\u00E7';
export const egrave = '\u00E8';
export const eacute = '\u00E9';
export const ecirc = '\u00EA';
export const euml = '\u00EB';
export const igrave = '\u00EC';
export const iacute = '\u00ED';
export const icirc = '\u00EE';
export const iuml = '\u00EF';
export const eth = '\u00F0';
export const ntilde = '\u00F1';
export const ograve = '\u00F2';
export const oacute = '\u00F3';
export const ocirc = '\u00F4';
export const otilde = '\u00F5';
export const ouml = '\u00F6';
export const divide = '\u00F7';
export const oslash = '\u00F8';
export const ugrave = '\u00F9';
export const uacute = '\u00FA';
export const ucirc = '\u00FB';
export const uuml = '\u00FC';
export const yacute = '\u00FD';
export const thorn = '\u00FE';
export const yuml = '\u00FF';
export const OElig = '\u0152';
export const oelig = '\u0153';
export const Scaron = '\u0160';
export const scaron = '\u0161';
export const Yuml = '\u0178';
export const fnof = '\u0192';
export const circ = '\u02C6';
export const tilde = '\u02DC';
export const Alpha = '\u0391';
export const Beta = '\u0392';
export const Gamma = '\u0393';
export const Delta = '\u0394';
export const Epsilon = '\u0395';
export const Zeta = '\u0396';
export const Eta = '\u0397';
export const Theta = '\u0398';
export const Iota = '\u0399';
export const Kappa = '\u039A';
export const Lambda = '\u039B';
export const Mu = '\u039C';
export const Nu = '\u039D';
export const Xi = '\u039E';
export const Omicron = '\u039F';
export const Pi = '\u03A0';
export const Rho = '\u03A1';
export const Sigma = '\u03A3';
export const Tau = '\u03A4';
export const Upsilon = '\u03A5';
export const Phi = '\u03A6';
export const Chi = '\u03A7';
export const Psi = '\u03A8';
export const Omega = '\u03A9';
export const alpha = '\u03B1';
export const beta = '\u03B2';
export const gamma = '\u03B3';
export const delta = '\u03B4';
export const epsilon = '\u03B5';
export const zeta = '\u03B6';
export const eta = '\u03B7';
export const theta = '\u03B8';
export const iota = '\u03B9';
export const kappa = '\u03BA';
export const lambda = '\u03BB';
export const mu = '\u03BC';
export const nu = '\u03BD';
export const xi = '\u03BE';
export const omicron = '\u03BF';
export const pi = '\u03C0';
export const rho = '\u03C1';
export const sigmaf = '\u03C2';
export const sigma = '\u03C3';
export const tau = '\u03C4';
export const upsilon = '\u03C5';
export const phi = '\u03C6';
export const chi = '\u03C7';
export const psi = '\u03C8';
export const omega = '\u03C9';
export const thetasym = '\u03D1';
export const upsih = '\u03D2';
export const piv = '\u03D6';
export const ensp = '\u2002';
export const emsp = '\u2003';
export const thinsp = '\u2009';
export const zwnj = '\u200C'; // ZERO WIDTH NON-JOINER
export const zwj = '\u200D'; // ZERO WIDTH JOINER
export const lrm = '\u200E';
export const rlm = '\u200F';
export const ndash = '\u2013';
export const mdash = '\u2014';
export const lsquo = '\u2018';
export const rsquo = '\u2019';
export const sbquo = '\u201A';
export const ldquo = '\u201C';
export const rdquo = '\u201D';
export const bdquo = '\u201E';
export const dagger = '\u2020';
export const Dagger = '\u2021';
export const bull = '\u2022';
export const hellip = '\u2026';
export const permil = '\u2030';
export const prime = '\u2032';
export const Prime = '\u2033';
export const lsaquo = '\u2039';
export const rsaquo = '\u203A';
export const oline = '\u203E';
export const frasl = '\u2044';
export const euro = '\u20AC';
export const image = '\u2111';
export const weierp = '\u2118';
export const real = '\u211C';
export const trade = '\u2122';
export const alefsym = '\u2135';
export const larr = '\u2190';
export const uarr = '\u2191';
export const rarr = '\u2192';
export const darr = '\u2193';
export const harr = '\u2194';
export const crarr = '\u21B5';
export const lArr = '\u21D0';
export const uArr = '\u21D1';
export const rArr = '\u21D2';
export const dArr = '\u21D3';
export const hArr = '\u21D4';
export const forall = '\u2200';
export const part = '\u2202';
export const exist = '\u2203';
export const empty = '\u2205';
export const nabla = '\u2207';
export const isin = '\u2208';
export const notin = '\u2209';
export const ni = '\u220B';
export const prod = '\u220F';
export const sum = '\u2211';
export const minus = '\u2212';
export const lowast = '\u2217';
export const radic = '\u221A';
export const prop = '\u221D';
export const infin = '\u221E';
export const ang = '\u2220';
export const and = '\u2227';
export const or = '\u2228';
export const cap = '\u2229';
export const cup = '\u222A';
export const int = '\u222B';
export const there4 = '\u2234';
export const sim = '\u223C';
export const cong = '\u2245';
export const asymp = '\u2248';
export const ne = '\u2260';
export const equiv = '\u2261';
export const le = '\u2264';
export const ge = '\u2265';
export const sub = '\u2282';
export const sup = '\u2283';
export const nsub = '\u2284';
export const sube = '\u2286';
export const supe = '\u2287';
export const oplus = '\u2295';
export const otimes = '\u2297';
export const perp = '\u22A5';
export const sdot = '\u22C5';
export const lceil = '\u2308';
export const rceil = '\u2309';
export const lfloor = '\u230A';
export const rfloor = '\u230B';
export const loz = '\u25CA';
export const spades = '\u2660';
export const clubs = '\u2663';
export const hearts = '\u2665';
export const diams = '\u2666';
export const lang = '\u27E8';
export const rang = '\u27E9';
export const esc = '\u001B';
export const newLine = '\u000A';
